<template>
  <el-tabs v-model="mainTab" type="card" style="margin: 10px">
    <el-tab-pane label="Brand" name="brand">
      <el-button-group class="mb10">
        <el-button type="primary" size="small" :plain="typeTab !== 1" @click="typeTab = 1">Pass list</el-button>
        <el-button type="primary" size="small" :plain="typeTab !== 2" @click="typeTab = 2">Block list</el-button>
      </el-button-group>
      <template v-if="typeTab === 1">
        <el-input ref="keyword" v-model="queryForm.keyword" clearable @input="search" @focus="$refs.keyword.select()" maxlength="128" class="search" placeholder="Search"></el-input>
        <table class="table">
          <tr v-for="(item) in tableData" :key="item.brandId">
            <td valign="top" width="150">
              <div class="brand-name">{{ item.brandName }}</div>
            </td>
            <td>
              <el-input v-model="item.boutiqueBrandName" size="medium" style="width: 200px" @keydown.native.enter="addBrandMappingPass(item)" maxlength="128" placeholder="boutique Brand"></el-input>
              <div class="tag-group">
                <div class="tag" v-for="(tag, bindex) in item.passArray" :key="bindex">{{ tag.boutiqueBrandName }}<i @click="delBrandMappingPass(item, bindex)" class="el-icon-circle-close"></i></div>
              </div>
            </td>
          </tr>
        </table>
        <el-pagination
          style="text-align: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryForm.currentPage"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="queryForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </template>
      <template v-else>
        <div class="block-list">
          Block brand：<el-input v-model="blockBrandName" size="medium" style="width: 200px" @keydown.native.enter="addBrandMappingBlock()" maxlength="128" placeholder="boutique Brand"></el-input>
          <div class="tag-group">
            <div class="tag" v-for="(tag, bindex) in blockList" :key="bindex">{{ tag.boutiqueBrandName }}<i @click="delBrandMappingBlock(tag)" class="el-icon-circle-close"></i></div>
          </div>
        </div>
      </template>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import * as _ from "lodash";
import {
  getBrandMappingPassList,
  addBrandMappingPass,
  delBrandMappingPass,
  getBrandMappingBlockList,
  addBrandMappingBlock,
  delBrandMappingBlock
} from '../../../api/mapping_cn';

export default {
  data() {
    return {
      mainTab: 'brand',
      typeTab: 1, // 1 Pass list 2 Block list
      total: 0,
      queryForm: {
        currentPage: 1,
        pageSize: 25,
        keyword: '',
      },
      tableData: [],
      blockBrandName: '',
      blockList: [],
    };
  },
  mounted() {
    this.getBrandMappingPassList();
    this.searchFn = _.debounce(this.getBrandMappingPassList, 200);
    this.getBrandMappingBlockList();
  },
  methods: {
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getBrandMappingPassList();
    },
    handleCurrentChange(currentPage) {
      this.queryForm.currentPage = currentPage;
      this.getBrandMappingPassList();
    },
    search() {
      this.queryForm.currentPage = 1;
      this.searchFn();
    },
    getBrandMappingPassList() {
      getBrandMappingPassList({
        currentPage: this.queryForm.currentPage,
        pageSize: this.queryForm.pageSize,
        brandName: this.queryForm.keyword,
      }).then((res) => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    addBrandMappingPass(item) {
      if (!item.boutiqueBrandName) {
        this.$message('请输入内容');
        return;
      }
      addBrandMappingPass({
        brandId: item.brandId,
        boutiqueBrandName: item.boutiqueBrandName,
      }).then(res => {
        if (res.data && res.data.code == '200') {
          if (!item.passArray) {
            item.passArray = [];
          }
          item.passArray.push({
            brandMapId: res.data.data.brandMapId,
            boutiqueBrandName: res.data.data.boutiqueBrandName,
          });
          this.$message.success('添加成功');
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      })
      item.boutiqueBrandName = '';
    },
    delBrandMappingPass(item, index) {
      delBrandMappingPass({
        brandMapId: item.passArray[index].brandMapId,
      }).then(res => {
        if (res.data && res.data.code == '200') {
          item.passArray.splice(index, 1);
          this.$message.success('删除成功');
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      })
    },
    getBrandMappingBlockList() {
      getBrandMappingBlockList().then(res => {
        if (res.data && res.data.data) {
          this.blockList = res.data.data.list;
        }
      })
    },
    addBrandMappingBlock() {
      if (!this.blockBrandName) {
        this.$message('请输入内容');
        return;
      }
      addBrandMappingBlock({
        boutiqueBrandName: this.blockBrandName,
      }).then(res => {
        if (res.data && res.data.code == '200') {
          this.getBrandMappingBlockList();
          this.$message.success('添加成功');
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      })
      this.blockBrandName = '';
    },
    delBrandMappingBlock(tag) {
      delBrandMappingBlock({
        brandMapId: tag.brandMapId
      }).then(res => {
        if (res.data && res.data.code == '200') {
          this.getBrandMappingBlockList();
          this.$message.success('删除成功');
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('系统异常');
      })
    },
  },
};
</script>

<style lang="less" scoped>
.mb10 {
  margin-bottom: 10px;
}
.search {
  display: block;
  width: 310px;
}
.table {
  width: 100%;
  margin: 10px 0;
  border-spacing: 0;
  border-collapse: collapse;

  tr{
    border-bottom: 1px solid #ebeef5;
    
    &:hover {
      background-color: #f5f7fa;
    }
  }
  td {
    padding: 10px;
  }
}
.brand-name {
  margin-top: 8px;
  font-size: 16px;
}
.tag-group {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
}
.tag {
  position: relative;
  margin: 10px 10px 0 0;
  padding: 5px 26px 5px 8px;
  border: 1px solid #DCDFE6;
  border-radius: 5px;

  i {
    position: absolute;
    top: 50%;
    right: 0;
    padding: 8px 5px;
    margin-top: -16px;
    line-height: 100%;
    cursor: pointer;

    &:hover {
      color: #000;
      font-weight: bold;
    }
  }

  &:hover{
    border-color: #C0C4CC;
  }
}
.block-list {
}
</style>
